import { render, staticRenderFns } from "./ScreenView.vue?vue&type=template&id=42f195d1"
import script from "./ScreenView.vue?vue&type=script&lang=js"
export * from "./ScreenView.vue?vue&type=script&lang=js"
import style0 from "./ScreenView.vue?vue&type=style&index=0&id=42f195d1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports